import { ProjectTeamMember } from "./programInfoUtils";
import { formatTeamRole, getRowBgColor, getTeamMemberName } from "./programInfoUtils";
import s from "./ProgramInfo.module.css";

type TeamMembersTableProps = {
  members: ProjectTeamMember[];
  isLoading: boolean;
  search: string;
  onRemove: (member: ProjectTeamMember) => void;
};

const TeamMembersTable = ({
  members,
  isLoading,
  search,
  onRemove,
}: TeamMembersTableProps) => {
  if (!members.length) {
    return (
      <div className={s.noDataBlock}>
        <h3>
          {search.trim() ? "No team members found" : "No team members in this project"}
        </h3>
      </div>
    );
  }

  return (
    <div className={s.teamListBlock}>
      {members.map((member, index) => (
        <div
          key={member._id}
          className={s.teamRow}
          style={{ backgroundColor: getRowBgColor(index) }}
        >
          <span>{getTeamMemberName(member)}</span>
          <span>{member.user?.email || "-"}</span>
          <span>{member.user?.shortId || "-"}</span>
          <span className={s.rolesCell}>
            {member.roles.map((role) => (
              <span key={role} className={s.roleBadge}>
                {formatTeamRole(role)}
              </span>
            ))}
          </span>
          <span>
            <button
              type="button"
              className={s.removeTeamBtn}
              onClick={() => onRemove(member)}
              disabled={isLoading}
            >
              Remove
            </button>
          </span>
        </div>
      ))}
    </div>
  );
};

export default TeamMembersTable;
